import React, { Fragment, useState, ChangeEvent } from "react";
import { RootState } from "../../reducers";
import { useSelector, useDispatch } from "react-redux";
import { TorrentNode, isTorrentFolder, TorrentFolder, TorrentFile, Torrent } from "../../types";
import { makeStyles, Checkbox, Collapse } from "@material-ui/core";
import {thunkToggleTorrentFilesWanted, thunkRenameTorrentFile} from '../../thunks';
import Editable from '../Shared/Editable';


const useStyles = makeStyles({
  tree: {
    paddingLeft: '1em',
    listStyleType: 'none',
    '& span': {
      cursor: 'pointer',
    }
  },
  editable: {
    display: 'inline',
    '& div': {
      display: 'inline'
    }
  }
})

function RenderFolder(props: { node: TorrentFolder }) {
  const { node } = props;
  const dispatch = useDispatch();
  const fillFiles = (node: TorrentFolder, all: TorrentFile[]) => {
    for (let child of node.children) {
      if (isTorrentFolder(child)) {
        fillFiles(child, all);
      } else {
        all.push(child as TorrentFile);
      }
    }
  }
  const active = useSelector((state: RootState) => state.torrent.active) as {id: number, hash: string};
  const handleFolderToggle = (e: ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    const allChildFiles: TorrentFile[] = [];
    fillFiles(node, allChildFiles);
    dispatch(thunkToggleTorrentFilesWanted(
      active.id,
      active.hash,
      allChildFiles.map(n => n.indice),
      node.wanted !== 'all',
    ));
  }

  const [open, setOpen] = useState(true);
  const handleFolderClick = () => {
    setOpen(!open);
  }


  return (
    <Fragment>
      <Checkbox size="small" checked={node.wanted === 'all'} indeterminate={node.wanted === 'partial'} color="secondary" onChange={handleFolderToggle} />
      <span onClick={handleFolderClick}>{node.name}</span>
      <Collapse in={open}>
        <RenderNodes nodes={node.children} />
      </Collapse>
    </Fragment>
  )
}


function RenderFile(props: { node: TorrentFile }) {
  const { node } = props;

  const active = useSelector((state: RootState) => state.torrent.active) as Partial<Torrent> & {
    id: number, hash: string
  };
  const dispatch = useDispatch();
  const handleFileToggle = () => {
    dispatch(thunkToggleTorrentFilesWanted(active.id, active.hash, [node.indice], !node.wanted));
  }
  const handleRenameFile = (filename: string) => {
    // const newName = node.name.substring(0, node.name.lastIndexOf('/') + 1) + filename;
    dispatch(thunkRenameTorrentFile(active.id, active.hash, node.name, filename));
  }

  return (
    <Fragment>
      <Checkbox size="small" checked={node.wanted} color="primary" onChange={handleFileToggle} />
      <Editable value={node.filename} pending={active.pending} onSubmit={handleRenameFile} />
    </Fragment>
  )
}


function RenderNodes(props: { nodes: TorrentNode[] }) {
  const classes = useStyles();
  const { nodes, ...rest } = props;

  return (
    <ul className={classes.tree} {...rest}>
      {nodes.map(node =>
        <li key={node.name}>
          {isTorrentFolder(node) && <RenderFolder node={node} />}
          {!isTorrentFolder(node) && <RenderFile node={node} />}
        </li>
      )}
    </ul>
  )
}


export default function Files() {
  const active = useSelector((state: RootState) => state.torrent.active) as Partial<Torrent>;

  return (
    <Fragment>
    {active.nodes && <RenderNodes nodes={active.nodes} />}
    </Fragment>
  )
}
